import { Global } from '@emotion/react';
import { inject, observer } from 'mobx-react';

export type IHeaderProps = object;

const MantineOverride: React.FC<IHeaderProps> = inject()(
  observer(() => {
    return (
      <Global
        styles={{
          ':root': {
            '--mantine-color-blue-filled': '#1C7ED6!important', // Surcharge de la couleur
            // pdfjs-dist/web/pdf_viewer.css declares `:root { color-scheme: light dark }`,
            // which overrides Mantine's color-scheme app-wide. On an OS in dark mode this
            // makes native `light-dark()` CSS and native form controls render dark. The app
            // is light-only, so force the document color-scheme back to light.
            colorScheme: 'light !important',
          },
          '.question-error-highlight': {
            animation: 'questionErrorPulse 2s ease-in-out',
            border: '2px solid #fa5252',
            borderRadius: '8px',
            boxShadow: '0 0 10px rgba(250, 82, 82, 0.3)',
          },
          '@keyframes questionErrorPulse': {
            '0%': {
              boxShadow: '0 0 5px rgba(250, 82, 82, 0.5)',
            },
            '50%': {
              boxShadow: '0 0 20px rgba(250, 82, 82, 0.8)',
            },
            '100%': {
              boxShadow: '0 0 5px rgba(250, 82, 82, 0.5)',
            },
          },
          '.mantine-Notifications-root': {
            zIndex: 9999,
          },
          '.mantine-Notifications-root[data-position="top-center"]': {
            width: '300px',
            maxWidth: '300px',
            top: '25vh',
          },
          '.mantine-AppShell': {
            display: 'flex',
            flexDirection: 'row',
          },
          '.mantine-AppShell-navbar': {
            position: 'fixed',
            left: '0 !important',
            right: 'auto !important',
            top: 'calc(60px + var(--safe-area-inset-top, 0px)) !important',
            bottom: '0 !important',
            // The box itself extends to the true bottom edge (no safe-area subtraction here) so
            // its background fills the home-indicator strip instead of leaving it blank; the
            // safe-area is instead applied as padding on the footer content (see SideBar.tsx).
            height:
              'calc(100vh - 60px - var(--safe-area-inset-top, 0px)) !important',
            maxHeight:
              'calc(100vh - 60px - var(--safe-area-inset-top, 0px)) !important',
            order: 0,
            overflow: 'visible',
            // iOS Safari's 100vh is the "large viewport" (chrome collapsed), taller than
            // what's actually visible when the address bar / toolbar are expanded (e.g. right
            // after opening the PWA). 100dvh tracks the real visible viewport so the drawer's
            // footer doesn't render behind the browser chrome.
            '@supports (height: 100dvh)': {
              height: 'calc(100dvh - 60px - var(--safe-area-inset-top, 0px)) !important',
              maxHeight: 'calc(100dvh - 60px - var(--safe-area-inset-top, 0px)) !important',
            },
          },
          '.mantine-AppShell-main': {
            marginRight: '0 !important',
            order: 1,
            flex: '1 1 auto',
            width: '100%',
            maxWidth: '100%',
            overflowX: 'auto',
            boxSizing: 'border-box',
          },
        }}
      />
    );
  }),
);

export default MantineOverride;
